let ScanCard = function(cardData) {
    this.cardNumber = "";
    this.cardName = "";

    this.toJSON = function() {
        return {
            "cardNumber": this.cardNumber,
            "cardName": this.cardName
        }
    };

    if (cardData) {
        this.cardNumber = cardData.cardNumber;
        this.cardName = cardData.cardName;
    }
};

export default ScanCard;
